import React, { useContext, useEffect, useState } from 'react'
import { useHistory, useLocation } from 'react-router-dom';
import { serverInfo } from '../../App';
import Navigation from '../Layouts/Header/Navigation';
import axios from "axios";

function Ipay88() {



    return (




        <>
            <Navigation totalNotification={0} />
            <div className="h-100 d-flex justify-content-center">
                <iframe src={'https://backend.hellosuperstars.com/ipay88-make-payment/12/1/livechat/5'}
                    style={{
                        display: 'block',
                        border: 'none',
                        height: 700,
                        width: '100vw',
                    }}
                    sandbox='allow-scripts allow-modal'
                    loading='lazy'
                    title='Custom title'
                >
                </iframe>
            </div>

        </>
    )
}

export default Ipay88
